import { z } from 'zod';
import { PlanDTO, SubscriptionDTO } from './billing.js';
export const AiConfigKey = z.enum([
    'default_model',
    'fallback_model',
    'embedding_model',
    'system_prompt_template',
    'max_tokens',
    'temperature',
    'tool_definitions',
    'rag_top_k',
    'chunk_size_tokens',
    'chunk_overlap_tokens',
]);
export const AiConfigEntry = z.object({
    key: AiConfigKey,
    value: z.unknown(),
    description: z.string().nullable(),
    updatedBy: z.string().uuid().nullable(),
    updatedAt: z.string(),
});
export const AdminUserListItem = z.object({
    id: z.string().uuid(),
    email: z.string(),
    name: z.string().nullable(),
    role: z.enum(['owner', 'admin', 'agent']),
    websiteCount: z.number().int().nonnegative(),
    balanceCents: z.number().int(),
    createdAt: z.string(),
});
export const UsageStat = z.object({
    date: z.string(),
    conversations: z.number().int().nonnegative(),
    messages: z.number().int().nonnegative(),
    tokens: z.number().int().nonnegative(),
    costCents: z.number().int().nonnegative(),
});
/** One row in the admin "manage plans" modal: a website owned by the
 * target user, plus the current per-website subscription + plan tier (if
 * any). Returned by GET /v1/admin/users/:id/subscriptions. */
export const AdminUserSubscriptionItem = z.object({
    websiteId: z.string().uuid(),
    websiteName: z.string(),
    websiteDomain: z.string(),
    subscription: SubscriptionDTO.nullable(),
    plan: PlanDTO.nullable(),
});
/** Body of POST /v1/admin/users/:id/subscriptions/:websiteId/plan. */
export const AdminSetUserPlanInput = z.object({
    planId: z.string().uuid(),
});
//# sourceMappingURL=admin.js.map